import { Component, OnInit, Inject } from "@angular/core";
import { WtfAnimations } from "../../../../../../utils/others/core/animations";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { SatReportService } from "../../../../../../services/report-sat/sat-report.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wtf-sat-error-report",
    templateUrl: "./sat-error-report.component.html",
    animations: WtfAnimations,
    providers: [SatReportService],
})
export class SatErrorReportComponent implements OnInit {
    campaignId: any;
    campaignData: any;
    chartData: any;

    dialogTitle: string;
    action: RecordAction;

    loading = true;

    errorsData: any;

    constructor(
        public dialogRef: MatDialogRef<SatErrorReportComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: SatReportService,
        private translateService: TranslateService
    ) {
        const { campaignId, campaignName } = data;
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.campaignId = campaignId;
        this.dialogTitle = "Envíos Fallidos";
        this.dialogTitle = this.translateService.instant(this.dialogTitle);
        this.dialogTitle = ` ${campaignName} - ${this.dialogTitle}`;
        this.campaignData = data;
    }

    ngOnInit(): void {
        this.getData();
    }

    getData() {
        this.service
            .getErrorDetails(this.campaignId, { type: "sat" })
            .subscribe((result) => {
                this.errorsData = result;
                this.loading = false;
            });
    }
}
